import './css/icons.css'

import './css/style.css'

import './css/sprite.css'

import 'es6-promise/auto'

import './polyfills'

import Vue from 'vue'

import LoadScript from 'vue-plugin-load-script'
import VueTheMask from 'vue-the-mask'
import * as uiv from 'uiv'

import { environment } from '@octadesk-tech/services'
import sanitizeHtml from './plugins/sanitize-html'

Vue.config.productionTip = false
Vue.use(LoadScript)
Vue.use(VueTheMask)
Vue.use(uiv)
Vue.use(sanitizeHtml)

const isProduction = process.env.NODE_ENV === 'production'

if (isProduction) {
  environment.resolveEnvironment()
  import('./lazy-load-main')
} else {
  import('./environment')
  import('./lazy-load-main')
}
